exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-icon {\n  font-family: 'icomoon' !important;\n  font-size: 1 rem;\n  line-height: 1;\n  margin-right: 10px; }\n\n.error-template {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/forgot-password/forgot-password.component.scss
// module id = ../../../../../src/app/forgot-password/forgot-password.component.scss
// module chunks = main